/*
    This file is part of Universal Sequences.
    Universal Sequences is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequences is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import ReactDOM  from 'react-dom';
import React, { Component } from 'react';
import SequencerToolbar from 'components/toolbar/SequencerToolbar.js';
import SubPageHeader from 'components/SubPageHeader.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import ModsModal from 'components/modals/ModsModal.js';
import PulseLoader from 'react-spinners/PulseLoader'
import { connect } from "react-redux";
import {
    setViewMode,
    setShowModsModal,
    setSelectedTrackSlice
} from 'actions/index.js';
import Colors from 'Colors.js';
import {updateStepParameter} from 'operations/actions.js';
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import Dropdown from 'react-dropdown'
import {AUDIO, INSTRUMENT, SAMPLER} from 'constants/track-types.js';
import Effects from 'Effects.js';
import YoutubeInfo from 'components/Youtube.js';
import {setContextualHelp} from "actions/index.js";
import {TRACK_PARAMETERS} from 'constants/contextual-help.js';
import {DETAIL_VIEW_HAS_SELECTED_SLICE} from 'constants/contextual-help.js';
import SoundDetail from 'SoundDetail.js';
import SoundTagEditor from 'SoundTagEditor.js';
import { Button } from 'reactstrap';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Keyboard from 'components/midi/Keyboard.js';
import ContextualHelpComponent from 'components/sidebar/ContextualHelpComponent.js';
import MidiPads from 'components/midi/MidiPads.js';
import '../DetailsView.scss';

const colors = new Colors();

class ConnectedDetailsView extends Component {
    constructor(props) {
        super(props);
        var showParameters = this.props.showParameters === undefined ? true :
            this.props.showParameters;

        this.state = {
            extracting: false,
            selectedSlice: 0,
            selectedMidiSlice: 0,
            samplerNumber: this.props.samplerNumber || 0,
            showParameters: showParameters,
            refined: this.parametersHasDecimals(),
            focused: false,
        };

        if (this.props.track.getTrackType() === SAMPLER) {
            this.linkMidi();

            document.addEventListener("keydown", (event) => this.onKeyDown(event));
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedSlice !== undefined && this.props.selectedSlice !== prevProps.selectedSlice) {
            this.setState({selectedSlice: this.props.selectedSlice});
        }
    }

    parametersHasDecimals() {
        return this.props.track.trackData.duration % 1 !== 0 ||
            this.props.track.trackData.transpose % 1 !== 0;
    }

    onGatedChange(opt) {
        document.activeElement.blur()
        this.props.track.gated = opt.target.value === 'gated';
        this.setState(this.state);
    }

    onChangeDuration(duration) {
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            let stepData = this.props.track.getStep(currentStep);
            stepData.duration = parseFloat(duration);
            this.props.track.trackData.duration = parseFloat(duration);
        } else {
            this.props.track.trackData.duration = parseFloat(duration);
        }
    }

    onChangeTranspose(transpose) {
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            let stepData = this.props.track.getStep(currentStep);
            stepData.transpose = parseFloat(transpose);
            this.props.track.trackData.transpose = parseFloat(transpose);
        } else {
            this.props.track.trackData.transpose = parseFloat(transpose);
        }
    }

    onChangeChop(chop) {
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            let stepData = this.props.track.getStep(currentStep);
            stepData.duration = parseFloat(chop);
            this.props.track.trackData.chop = parseInt(chop);
        } else {
            this.props.track.trackData.chop = parseInt(chop);
        }
    }

    onChangeVelocity(velocity) {
        let stepData = this.props.track.trackData;
        stepData.velocity = parseFloat(velocity);
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.velocity = parseFloat(velocity);
    }

    onChangeAttack(attack) {
        let stepData = this.props.track.trackData;
        stepData.attack = parseFloat(attack);
        if (this.props.sequencerEngine.isRecording) {
           let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.attack = parseFloat(attack);
    }

    onChangeRelease(release) {
        let stepData = this.props.track.trackData;
        stepData.release = parseFloat(release);
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.release = parseFloat(release);
    }

    onChangePitchAttack(attack) {
        let stepData = this.props.track.trackData;
        stepData.pitchAttack = parseFloat(attack);
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.pitchAttack = parseFloat(attack);
    }

    onChangePitchDecay(decay) {
        let stepData = this.props.track.trackData;
        stepData.pitchDecay = parseFloat(decay);
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.pitchDecay = parseFloat(decay);
    }

    onChangePitchSustain(sustain) {
        let stepData = this.props.track.trackData;
        stepData.pitchSustain = parseFloat(sustain);
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.pitchSustain = parseFloat(sustain);
    }

    onChangePitchRelease(release) {
        let stepData = this.props.track.trackData;
        stepData.pitchRelease = parseFloat(release);
        if (this.props.sequencerEngine.isRecording) {
            let currentStep = this.props.sequencerEngine.getCurrentStep();
            stepData = this.props.track.getStep(currentStep);
        }
        stepData.pitchRelease = parseFloat(release);
    }

    onChangeOffset(offset) {
        this.props.track.getSampler().offset = offset;
    }

    onSelectSlice(slice) {
        // check if there are any selected steps
        let state = this.props.sequencerEngine.state;
        let steps = state.keyboard.selectedPianoRollSteps;
        if (steps) {
            if (steps.every(x => x.track === this.props.track)) {
                let op = this.props.sequencerEngine.operationManager;
                steps.forEach(
                    x => op.dispatch(
                        updateStepParameter(this.props.track, x, x.sliceParameter, slice)));
            }
        }
        this.setState({
            selectedMidiSlice: slice,
            selectedSlice: slice});
        this.props.setSelectedTrackSlice(slice);
    }

    linkMidi() {
        let self = this;
        this.props.midiEngine.addNoteOnListener((input, noteOn) => {
            if (this.state.selectedMidiSlice != null && !this.props.track.isEnabled) {
                this.props.keyboardEngine.midiMap(input, noteOn, this.props.trackNumber, this.state.selectedMidiSlice);
                // need to release this note somehow
                this.props.sequencerEngine.keyboardHelper.onNoteDown(noteOn, true, input);
                this.state.selectedMidiSlice = null;
                this.setState(this.state);
            }
        });
    }

    onKeyDown(event) {
        var key = event.key;
        if (key === 'Tab') {
            var self = this;
            return true;
        } else if (this.state.selectedMidiSlice != null &&
                   (key.match(/^[a-z]+$/))) {
            if (!this.state.focused) {
                if (!this.props.keyboardEngine.hasKeyMapping(key)) {
                    this.props.keyboardEngine.map(key, this.props.trackNumber, this.state.selectedMidiSlice);
                }
                this.state.selectedMidiSlice = null;
                this.setState(this.state);
            }
        }
    }

    onChangeRefined(val) {
        document.activeElement.blur()
        this.state.refined = !this.state.refined;
        this.setState(this.state);
    }

    onChangeReversed(reversed) {
        document.activeElement.blur()
        this.props.track.trackData.reverse = !this.props.track.trackData.reverse;
        this.props.track.reverse(!this.isReversed());
        this.setState(this.state);
    }

    isReversed() {
        return this.props.track.isReversed();
    }

    onFocus() {
        this.setState({ focused: true});
    }

    onBlur() {
        this.setState({ focused: false});
    }

    onChangeName(e) {
        this.props.track.name = e.target.value;
        this.setState(this.state);
    }

    savePreset() {
        this.props.sequencerEngine.saveTrackPreset(this.props.trackNumber);
    }

    updatePreset() {
        this.props.sequencerEngine.updateTrackPreset(this.props.trackNumber);
    }

    async extractStems() {
        this.setState({extracting: true});
        await this.props.track.extractStems();
        this.props.setViewMode(this.props.parentView);
    }

    async extractGroove() {
        this.props.track.extractGroove();
        this.props.setViewMode(this.props.parentView);
    }

    render() {
        if (this.props.track == undefined ||
            !this.props.loaded) {
            return (
                <div></div>
            );
        } else {
            var track = this.props.track;
            let soundDetail = '';
            let sampler = undefined;
            let style = {};
            var trackData = this.props.track.trackData;
            if ( this.props.track.getSampler(this.state.samplerNumber)) {
                let selectedSlice = this.state.selectedSlice === undefined ?
                    undefined :
                    this.props.track.getSampler(this.state.samplerNumber).slices[this.state.selectedSlice];

                var tempo = this.props.track.getSampler(this.state.samplerNumber).tempo;
                sampler = track.getSampler(this.state.samplerNumber);
                let soundId = this.props.track.soundIds[this.state.samplerNumber]; 
                if (track.selectedRecording !== undefined) {
                    sampler = track.getSelectedRecordingSampler();
                    soundId = track.getSelectedRecordingSoundId();
                }
                if (soundId === undefined) {
                    soundId = "unknown";
                }
                style['background-image'] = 'linear-gradient(' +
                    colors.brighten(colors.getColorForHash(soundId), 0.12) + ', ' +
                    colors.brighten(colors.getColorForHash(soundId), 0.1) + ')';
                style['borderColor'] = colors.brighten(colors.getColorForHash(soundId), 0.65);

                soundDetail = (
                    <SoundDetail
                      bottomHeight={this.props.bottomHeight}
                      width={this.props.width}
                      onSoundIdChange={(id) => []} 
                      onClickThumbnail={(soundId) => []}
                      onChangeReversed={(e) => this.onChangeReversed(e)}
                      small={this.props.small}
                      onGetName={() => []} 
                      name={this.props.track.name}
                      track={this.props.track}
                      sampler={sampler}
                      div={this.props.div}
                      height={this.props.height}
                      onSelectSlice={(i) => this.onSelectSlice(i)}
                      onKeyDown={(e) => this.props.onKeyDown(e)}
                      selectedSlice={this.state.selectedSlice}
                      videoId={this.props.track.videoId}
                      soundId={soundId}
                      id={this.props.id}
                    >
                   </SoundDetail>);
 
            }
            let stepValue = this.state.refined ? 0.01 : 1;
            let durationMin = this.state.refined ? 0.01 : 1;
            let durationMax  = this.state.refined ? 2 : 64;
            let headerText = this.props.track.getName(this.props.samplerNumber);
            let _style = {
            };
            if (this.props.width) {
                _style.width = this.props.width + 5;
            }
        return (
            <div style={_style} className="bottom-details">
               <ModsModal parameters={this.props.track.trackData.parameters}/>
              {soundDetail}
                <ConditionedComponent condition={!this.state.extracting}>
                  {!this.props.hideKeyboard ?
                   <ContextualHelpComponent
                     trackNumber={this.props.trackNumber}
                     track={this.props.track}
                     mini={true}
                     sequencerEngine={this.props.sequencerEngine}
                     keyboardEngine={this.props.sequencerEngine.keyboardEngine}/>
                   : ''}
 
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.extracting}>
                  <div className="extracting-stems">Extracting stems... </div>
                </ConditionedComponent>
                <PulseLoader
                                         
                sizeUnit={"px"}
                size={10}
                color={'#123abc'}
                loading={this.state.extracting}
                />
 
              {this.state.showParameters ? 
                    <div
                          style={style}
                          onMouseOver={() => this.props.setContextualHelp(TRACK_PARAMETERS)}
                          onMouseLeave={() => this.props.setContextualHelp(undefined)}
                          className='sound-parameters sound-parameters-full panel'>
                                      <form>
                 </form>
                <form>
                    <div className="refined-checkbox-preferences">
                      <label>
                        <input 
                               type="checkbox"
                               value="reversed"
                               checked={this.props.track.isReversed()}
                               onChange={(e) => this.onChangeReversed(e.target.value)} />
                          Reversed
                      </label>
                    </div>
              </form>

                <div className="amp-envelopes">

                <EffectParameterSlider 
                      effectNumber={0}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                  min={durationMin}
                  max={durationMax}
                  step={stepValue}
                  isParameter={true}
                  parameter={trackData.durationParameter}
                  name="DURATION"></EffectParameterSlider>
                    <EffectParameterSlider
                      effectNumber={0}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                  min={1}
                  max={32}
                  isParameter={true}
                  parameter={trackData.chopParameter}
                  name="CHOP"/>
                <EffectParameterSlider 
                      min={-23}
                      max={23}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      isParameter={true}
                      parameter={trackData.transposeParameter}
                      refined={this.state.refined}
                      name="TRANSPOSE"/>
               <EffectParameterSlider 
                      min={0}
                      max={1}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      refined={this.state.refined}
                      isParameter={true}
                      step={0.1}
                      parameter={trackData.velocityParameter}
                      name="VELOCITY"/>
                 <EffectParameterSlider
                        min={0}
                        max={2000}
                        step={1}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                        refined={this.state.refined}
                      isParameter={true}
                        parameter={trackData.attackParameter}
                        unit='ms'
                        name="AMP ATTACK"/>
                      <EffectParameterSlider 
                            min={0}
                            max={8000}
                            refined={this.state.refined}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      isParameter={true}
                            parameter={trackData.releaseParameter}
                            unit='ms'
                            name="AMP RELEASE"/>
                    </div>
                 <div className="pitch-envelopes">
                <EffectParameterSlider 
                      min={0}
                      max={100}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      refined={this.state.refined}
                      isParameter={true}
                      step={0.1}
                      unit='%'
                      parameter={trackData.startParameter}
                      name="START"/>
                    <EffectParameterSlider 
                          min={0}
                          max={2000}
                          step={1}
                          isParameter={true}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                          refined={this.state.refined}
                          parameter={trackData.pitchAttackParameter}
                          unit='ms'
                  name="PITCH ATTACK"/>
                <EffectParameterSlider
                  min={0.01}
                  max={8000}
                  refined={this.state.refined}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      isParameter={true}
                  parameter={trackData.pitchDecayParameter}
                      unit='ms'
                  name="PITCH DECAY"/>
                    <EffectParameterSlider
                          min={-10}
                          max={10}
                          isParameter={true}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                          refined={this.state.refined}
                          step={0.01}
                          parameter={trackData.pitchSustainParameter}
                          name="PITCH SUSTAIN"/>
                
                <EffectParameterSlider 
                      min={0.01}
                      max={8000}
                      refined={this.state.refined}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      isParameter={true}
                      parameter={trackData.pitchReleaseParameter}
                      unit='ms'
                      name="PITCH RELEASE"/>
              </div>
               
               <form>
                    <div className="refined-checkbox-preferences">
                      <label>
                        <input 
                               type="checkbox"
                               value="refined"
                               checked={this.state.refined}
                               onChange={(e) => this.onChangeRefined(e.target.value)} />
                          Refine
                      </label>
                    </div>
              </form>
                   <div
                         onClick={() => this.props.setShowModsModal(true)}
                         className="mods-button common-button pink-button small-button">MODS</div>
              </div>
              : '' }
           </div>);
        }
    }
}

class Parameter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.defaultValue
        }
    }

    onChange(value) {
        this.state.value = value;
        this.props.change(value);
        this.setState(this.state);
    }
    render() {
        let step = this.props.refinedMode === true ? 0.01 :
            (this.props.step != undefined ? this.props.step : (this.props.max > 1 ? 1: 0.1));
        //let min = this.props.refinedMode === true ? 0.01 : this.props.min;
        return (<div className='sound-parameter'>
                <div className="sound-parameter-name">{this.props.name}: {this.state.value} {this.props.unit !== undefined ? this.props.unit : ''}</div>
                <ReactBootstrapSlider
                  value={this.state.value}
                  change={(e) => this.onChange(e.target.value)}
                step={step}
                  max={this.props.max}
                  min={this.props.min}
                  orientation="horizontal"
                  reversed={false}
                /> 

            </div>
                
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setViewMode: viewMode => dispatch(setViewMode(viewMode)),
        setShowModsModal: show => dispatch(setShowModsModal(show)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setSelectedTrackSlice: (slice) => dispatch(setSelectedTrackSlice(props.track.id, slice)),
    }
};

const mapStateToProps = (state, props) => {
    let track = props.track;
    return {
        id: track === undefined ? 0 :
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.presetName || track.getName(),
        selectedSlice: state.tracks.selectedTrackSlice[track.id],
        showingOnsets: state.waveform.showingOnsets,
        bottomHeight: state.arrangement.bottomHeight,
        loaded: track.isFrozen || (track && track.getSampler(0) && track.getSampler(0).isLoaded()),
        sampler: track && track.getSampler(0),
        isFrozen: track.isFrozen,
    };
};

const DetailsView = connect(mapStateToProps, mapDispatchToProps)(ConnectedDetailsView);
export default {DetailsView, Parameter};

/**
                  <div
                    onClick={() => this.extractStems()}
                    className="common-button magenta-button">
                    EXTRACT STEMS
                  </div>
                  <ConditionedComponent condition={this.props.showingOnsets}>
                    <div
                      onClick={() => this.extractGroove()}
                      className="common-button magenta-button">
                      EXTRACT GROOVE
                    </div>
                  </ConditionedComponent>
*/
